import { render, staticRenderFns } from "./TestContent.vue?vue&type=template&id=3a5fe020&scoped=true&"
import script from "./TestContent.vue?vue&type=script&lang=js&"
export * from "./TestContent.vue?vue&type=script&lang=js&"
import style0 from "./TestContent.vue?vue&type=style&index=0&id=3a5fe020&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5fe020",
  null
  
)

export default component.exports